import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { convertNumberComma } from 'components/elements/numberWithComma';
import { useGlobalStore } from 'lib/DataStore';
import { Trend } from 'lib/apis/entity/insight/type';
import { useOwnTranslate } from 'lib/hooks/useOwnTranslate';
import { nFormatter } from 'lib/utils/helpers/numberFormat';
import { colors } from 'lib/utils/tailwindProps';

type Props = {
  chartData: Trend[];
  mode: 'RAW' | 'PERCENTAGE'
};

const HousePricesTrendsChart = ({ chartData,
  mode
}: Props) => {
  const { t } = useOwnTranslate('');
  const { userDevice } = useGlobalStore();
  const symbolicChartData = chartData?.map((c) => ({
    date: c.periodSymbol,
    value:
      typeof c.value === 'number' && !isNaN(c.value)
        ? +c.value.toFixed(0)
        : null,
  }));

  const symbolMode = mode === 'PERCENTAGE' ? '%' : t('global.toman');

  // const symbol =
  //   mode === 'PERCENTAGE'
  //     ? '%'
  //     : trendType?.symbol === 't'
  //       ? t('global.toman')
  //       : '';

  return (
    <>
      <ResponsiveContainer height={400}>
        <AreaChart
          id={'housePricesChart'}
          data={symbolicChartData}
          margin={{ bottom: 16 }}
        >
          <defs>
            <linearGradient id="bgColor" x1=".5" x2=".5" y2="1">
              <stop stopColor={colors.primary[300]} stopOpacity=".1" />
              <stop
                offset=".956"
                stopColor={colors.primary[300]}
                stopOpacity=".1"
              />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="date"
            type="category"
            tickLine={false}
            axisLine={false}
            tickMargin={16}
            style={{ fontSize: userDevice === 'MOBILE' ? 10 : 12 }}
          />
          <YAxis
            dataKey="value"
            type="number"
            tickSize={2}
            width={userDevice === 'MOBILE' ? 72 : 80}
            tickFormatter={(value) => `${nFormatter(value, 2)} ${symbolMode}`}
            tickMargin={64}
            tickLine={false}
            axisLine={false}
            style={{ fontSize: userDevice === 'MOBILE' ? 10 : 12 }}
            domain={([dataMin, dataMax]) => {
              return [dataMin, dataMax];
            }}
          ></YAxis>
          <CartesianGrid vertical={false} stroke={colors.white} />
          <Area
            dataKey="value"
            stroke={colors.primary[500]}
            strokeWidth={2}
            fill={'url(#bgColor)'}
          />
          <Tooltip
            formatter={(value) => [` ${convertNumberComma(+value)} ${symbolMode}`]}
          />
        </AreaChart>
      </ResponsiveContainer>
    </>
  );
};

export default HousePricesTrendsChart;
